import Markdown from '@/components/common/Markdown'
import { Disclosure } from '@headlessui/react'
import { IconContext } from 'react-icons'
import { BsChevronDown } from 'react-icons/bs'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import Loader from '@/components/common/Loader'

const FaqContent = ({ data, isLoading }) => {
  if (isLoading) return <Loader />
  return (
    <>
      <div className="w-full mt-10 mb-8">
        <h1 className="tagline-font text-white tracking-wide text-2xl maxSm:mt-2 maxLg:mt-6">
          {data?.faqTitle}
        </h1>
        <h6 className="text-gray-400 md:text-lg text-sm font-normal">{data?.faqSubtitle}</h6>
      </div>
      {data?.faqs?.map((item, index) => (
        <div className="py-1.5 w-full " key={index}>
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button className="w-full">
                  <div className="flex justify-between felx-wrap items-center bg-custom-gray-500 font-normal font-AktivGrotesk tracking-wide text-white  md:text-lg px-4 md:leading-10 md:px-7 md:p-2 p-3 text-base font-medium">
                    <div className="text-left w-10/12 font-bold">{item?.question}</div>
                    <div>
                      <IconContext.Provider
                        value={{
                          size: '1em',
                          className: `${open ? 'rotate-180 transform' : ''} ms-1 me-3`,
                        }}
                      >
                        <BsChevronDown />
                      </IconContext.Provider>
                    </div>
                  </div>
                </Disclosure.Button>
                <Disclosure.Panel className="flex justify-between items-center flex-wrap w-full bg-custom-gray-500 font-normal tracking-wide text-white text-sm md:pl-6 md:pr-20 px-4 pb-6">
                  <Markdown
                    data={documentToHtmlString(item?.answer)}
                    isHyperlink={true}
                    isPadding={true}
                    isRichText={true}
                  />
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      ))}
    </>
  )
}

export default FaqContent
